import * as utils from "../../utils";
import {objectToFormData} from "../../utils";
import {fetchUserCargos} from "./cargos";
import $ from "jquery";

export const getUserData = async (userID, errorHandling) => {
    //console.log("/usuarios/" + userID + "")
    let data = await utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/usuarios/" + userID, errorHandling);
    //console.log("/usuarios/" + userID + "2")
    // Get a tipo formacion de usuario
    ///console.log("/usuarios/" + userID + "/estudios")
    const datosTipoFormacionPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/usuarios/" + userID + "/estudios", errorHandling);
    //console.log("/usuarios/" + userID + "/estudios")

    //Get a informatica de usuario
    const datosInformaticaPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/usuarios/" + userID + "/informatica", errorHandling);

    //Get a Idiomas de usuario
    const datosIdiomasPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/usuarios/" + userID + "/idiomas", errorHandling);

    const datosTipoFormacion = await datosTipoFormacionPromise;
    const datosInformatica = await datosInformaticaPromise;
    const datosIdiomas = await datosIdiomasPromise;

    data = {
        ...data,
        datosTipoFormacion,
        datosInformatica,
        datosIdiomas
    }

    // Si el usuario es una hermana
    if (data.sister || data.type === "Monja") {
        // Get a situacion particular hermana
        //const datosPersonales = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/hermanas/" + cstate.DatosUsuario.sister.id + "/situacionPersonal", errorHandling);

        // Get a datos testamento hermana
        const datosTestamentoPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/hermanas/" + data.sister.id + "/testamento", errorHandling);

        // Get a datos formacion de las etapas vida religiosa
        //const datosEtapasReligiosasPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/hermanas/" + data.sister.id + "/votos", errorHandling);

        // Get a adscripcion de la hermana
        //const adscripcionDestinoPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/hermanas/" + data.sister.id + "/destino", errorHandling);

        // Get a formacion religiosa
        const datosFormacionReligiosaPromise = utils.callAjaxGet("GET", process.env.REACT_APP_API_URL + "/hermanas/" + data.sister.id + "/estudiosReligiosos", errorHandling);

        const datosPersonales = [];
      //  const datosEtapasReligiosas = await datosEtapasReligiosasPromise;
        const datosFormacionReligiosa = await datosFormacionReligiosaPromise;
        const datosTestamento = await datosTestamentoPromise;
       // const adscripcionDestino = await adscripcionDestinoPromise;

        data = {
            ...data,
            datosPersonales,
            //datosEtapasReligiosas,
            datosFormacionReligiosa,
            datosTestamento,
           // adscripcionDestino,
        };
    }
    const cargos = await fetchUserCargos(userID, errorHandling);
    data = {
        ...data,
        cargos
    }
    return data;
}

export const getSisterList = async (errorHandling) => {
    return (await utils.callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/hermanas`, errorHandling));
};

export const getExternList = async (errorHandling) => {
    return (await utils.callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/externos`, errorHandling));
};

export const getExternByFamily = async (familia, errorHandling, nombre = null) => {
    return (await utils.callAjaxGet("GET",
        `${process.env.REACT_APP_API_URL}/externos?familia=${familia}${nombre ? `&findName=${nombre}` : ''}`,
        errorHandling));
}

export const postExtern = async (data) => {
    delete data.id;
    const formData = objectToFormData(data, true);
    let settings = {
        url: process.env.REACT_APP_API_URL + `/externos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: formData,
    };
    return $.ajax(settings);
};

export const putExtern = async (data) => {
    const formData = objectToFormData(data, true);
    let settings = {
        url: process.env.REACT_APP_API_URL + `/externos/${data.id}`,
        method: "PUT",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: formData,
    };
    return $.ajax(settings);
};
